
import { User } from '@/interface/auth/user.interface';
import { defineComponent } from 'vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import LoaderCube from "@/components/timer/Loader.vue";

export default defineComponent({
  name: "RegisterModal",
  components: {
    LoaderCube
  },
  data() {
    return {
      user: {
        name: '',
        email: '',
        username: '',
        password: '',
      } as User,
      confirmPassword: '',

      successFullMessage: false,

      errors: [],
      loading: false
    }
  },
  methods: {
    toggleModal(): void{
      this.ToggleAuthRegisterModal();
    },
    register(): void {
      if (this.checkPassword && !this.checkUsernameIsInvalid){
        this.loading = true
        this.registerUser({
          name: this.user.name,
          email: this.user.email,
          password: this.user.password,
          username: this.user.username
        }).then(res => {
          console.log(res)
          if (this.registerMessage.error){
            this.loading = false;  
          }else {
            this.successFullMessage = true;
            this.loading = false;
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    ...mapMutations('authModule', ['ToggleAuthRegisterModal']),
    ...mapActions('authModule', ['registerUser'])
  },
  computed: {
    ...mapState('authModule', ['authRegisterModal', 'registerMessage']),
    checkPassword(): boolean{
      if (this.user.password !== "" && this.confirmPassword !== "")
        return this.user.password == this.confirmPassword;
      return true;
    },
    checkUsernameIsInvalid(): boolean {
      //eslint-disable-next-line
      return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(this.user.username);
    }
  }
})
